import { createContext } from 'preact';
const TableSectionContext = createContext(null);
export default TableSectionContext;
//# sourceMappingURL=TableSectionContext.js.map